import { Badge, Tooltip, styled } from "@mui/material";
import type { ComponentType } from "react";
import type { SvgIconProps } from "@mui/material";
import { MenuTooltip } from "../atoms/Menu";
import { COLORS } from "../../constants/colors";

const ImgMenuContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected: boolean }>`
  width: 42px;
  height: 42px !important;
  border-radius: 10px;
  background-color: ${(props) =>
    props.selected ? COLORS.BORDER_MEDIUM : COLORS.TRANSPARENT};
  color: ${(props) =>
    props.selected ? COLORS.THEME_PRIMARY : COLORS.TEXT_BLACK};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.BORDER_MEDIUM};
  }
`;

const StyledBadge = styled(Badge)`
  & .MuiBadge-badge {
    width: 20px;
    top: 2px;
    right: 2px;
    color: ${COLORS.TEXT_WHITE};
    background-color: ${({ theme }) => theme?.palette?.accent?.main};
  }
`;

interface ImgMenuProps {
  Icon: ComponentType<SvgIconProps>;
  tooltip: string;
  selected: string;
  name: string;
  handleSelection: (name: string) => void;
  badge?: number;
}

const ImgMenu = ({
  Icon,
  tooltip,
  selected,
  name,
  handleSelection,
  badge = 0,
}: ImgMenuProps) => {
  const handleClick = () => {
    handleSelection(name);
  };

  const handleBadgeInvisiblity = () => badge <= 0;

  return (
    <Tooltip
      title={<MenuTooltip>{tooltip}</MenuTooltip>}
      placement="right"
      arrow
    >
      <ImgMenuContainer selected={selected === name} onClick={handleClick}>
        <StyledBadge invisible={handleBadgeInvisiblity()} badgeContent={badge}>
          <Icon />
        </StyledBadge>
      </ImgMenuContainer>
    </Tooltip>
  );
};

export { ImgMenu };
